import { Text } from "@radix-ui/themes";

interface BadgeBlockProps {
  label: string;
  color: "green" | "amber" | "red" | "blue" | "gray";
  size?: "sm" | "md" | "lg";
}

const COLOR_CLASSES: Record<string, string> = {
  green: "bg-malachite-100 text-malachite-800 border-malachite-300",
  amber: "bg-puntt-gold-3 text-puntt-gold-11 border-puntt-gold-6",
  red: "bg-puntt-red-3 text-puntt-red-11 border-puntt-red-6",
  blue: "bg-puntt-accent-3 text-puntt-accent-11 border-puntt-accent-6",
  gray: "bg-puntt-neutral-gray-3 text-puntt-neutral-gray-11 border-puntt-neutral-gray-6",
};

const SIZE_CLASSES: Record<string, string> = {
  sm: "px-2 py-0.5 text-xs",
  md: "px-3 py-1 text-sm",
  lg: "px-4 py-2 text-base font-semibold",
};

export function BadgeBlock({ label, color, size = "md" }: BadgeBlockProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full border font-medium ${COLOR_CLASSES[color] ?? COLOR_CLASSES.gray} ${SIZE_CLASSES[size] ?? SIZE_CLASSES.md}`}
    >
      <Text as="span">{label}</Text>
    </span>
  );
}
